<mat-menu class="popover" overlapTrigger="false" #popover="matMenu"
          [xPosition]="$xPosition()"
          [yPosition]="$yPosition()"
>
    <ng-template matMenuContent>
        <div class="popover-content" (click)="$event.stopPropagation()" (keyDown)="$event.stopPropagation()">
            <!-- popover content begin -->
            <ng-container *ngTemplateOutlet="$popoverContent()"></ng-container>
            <!-- popover content end  -->
        </div>
    </ng-template>
</mat-menu>

@if ($disabled()) {
    <div class="disabled">
        <ng-content></ng-content>
    </div>
} @else {
    <div [matMenuTriggerFor]="popover">
        <ng-content></ng-content>
    </div>
}
